const componentIds = {
  Tooltip: 'Tooltip',
};

export { componentIds };
